import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsIbmwatsonComponent } from './simple-icons-ibmwatson.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsIbmwatsonComponent ],
    exports:      [ SimpleIconsIbmwatsonComponent ],
    bootstrap:    []
})
export class SimpleIconsIbmwatsonModule {}
